import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './CheckboxIndicator.module.css';

interface CheckboxIndicatorProps extends HTMLAttributes<HTMLSpanElement> {
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  isHovered?: boolean;
  isFocused?: boolean;
  isActive?: boolean;
}

const CheckIcon = () => (
  <svg
    width="7"
    height="6"
    viewBox="0 0 7 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.583374 3.50004L2.33337 5.25004L6.41671 0.583374"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MinusIcon = () => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.icon}
  >
    <path
      d="M3 6H9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckboxIndicator = ({
  checked = false,
  indeterminate = false,
  disabled = false,
  isHovered = false,
  isFocused = false,
  isActive = false,
  className,
  ...rest
}: CheckboxIndicatorProps) => {
  const showChecked = checked;
  const showIndeterminate = indeterminate && !checked;

  return (
    <span
      className={classNames(
        styles.indicator,
        showChecked && styles.checked,
        showIndeterminate && styles.indeterminate,
        disabled && styles.disabled,
        isHovered && styles.hovered,
        isFocused && styles.focused,
        isActive && styles.active,
        className
      )}
      aria-hidden="true"
      data-checkbox-indicator
      data-checked={showChecked ? 'true' : undefined}
      data-indeterminate={showIndeterminate ? 'true' : undefined}
      {...rest}
    >
      <div className={styles.svgWrapper}>
        {(() => {
          if (showChecked) {
            return <CheckIcon />;
          }

          if (showIndeterminate) {
            return <MinusIcon />;
          }

          return null;
        })()}
      </div>
    </span>
  );
};
